// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const supplierGroupOperations = {
  groupNameSearch: ['get', '/supplier/group/name'] as const,
  updateGroupName: ['put', '/supplier/group/name'] as const,
  handleGroupNameSearch: ['post', '/supplier/group/name'] as const,
  handleGroupPost: ['post', '/supplier/group'] as const,
  handleSearchRequest: ['post', '/search'] as const,
  handleSearchGroupNames: ['post', '/search/groups/legacy_ids'] as const,
  handleSGASupplier: ['post', '/search/group'] as const,
  handleGroupNameSearch_1: ['post', '/search/group/names'] as const,
  handleGroupInfo: ['post', '/search/group/info'] as const,
  handleSearchAllGroups: ['get', '/search/{pageNum}'] as const,
  performHealthCheck: ['get', '/health'] as const
} as const;
